const actions = {
    updateSidebarWidth({commit}, width) {
        commit('UPDATE_SIDEBAR_WIDTH', width);
    },
    updateI18nLocale({commit}, locale) {
        commit('UPDATE_I18N_LOCALE', locale);
    },
    toggleContentOverlay({commit}) {
        commit('TOGGLE_CONTENT_OVERLAY');
    },
    updateTheme({commit}, val) {
        commit('UPDATE_THEME', val);
    },

    // VxAutoSuggest
    updateStarredPage({commit}, payload) {
        commit('UPDATE_STARRED_PAGE', payload)
    },

    //  The Navbar
    arrangeStarredPagesLimited({commit}, list) {
        commit('ARRANGE_STARRED_PAGES_LIMITED', list)
    },
    arrangeStarredPagesMore({commit}, list) {
        commit('ARRANGE_STARRED_PAGES_MORE', list)
    },

    SET_CAMPAIGNLIST(context, payload) {
        context.commit('SET_CAMPAIGNLIST', payload);
    },

    SET_ABTEST_FOR_NEW_AD(context, payload) {
        context.commit('SET_ABTEST_FOR_NEW_AD', payload);
    },

    SET_TEST_ID_FOR_RELOAD_FORM(context, payload) {
        context.commit('SET_TEST_ID_FOR_RELOAD_FORM', payload);
    },

    SET_WHIMAGE(context, payload) {
        context.commit('SET_WHIMAGE', payload);
    },


};

export default actions
